<!--&================= TITLE =================&-->
<div class="title-components">
  <h1>Contribuciones totales Processes</h1>
</div>

<!--&================= CONTAINER BAR NAVIGATION =================&-->

<div class="Options-Menu">
  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fas fa-hashtag"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="information">
        <div class="option">
          <div class="Option-Title"><h2>Total de Processes</h2></div>
          <div class="Input-Option">{{ DataChartAreaFIN.Total }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-charts">
  <div class="container-left">
    <div class="container-global-components chart-FIN">
      <app-simple-chart-arear [DataChartArea]="DataChartAreaFIN" />
    </div>
  </div>
</div>
